export default __webpack_public_path__ + "static/media/investment_female@3x.0d0586f5.png";